import { Controller } from "@hotwired/stimulus"

// PWA — registers the service worker at /sw.js, surfaces an "update available"
// toast when a new SW takes over, and tracks online/offline transitions with a
// matching toast pair. Bound to <body> in `estratos.erb`.
export default class extends Controller {
  static values = {
    swPath: { type: String, default: "/sw.js" },
  }

  connect() {
    if (!("serviceWorker" in navigator)) return
    this.registerServiceWorker()
    this.setupOnlineOffline()
  }

  disconnect() {
    if (this._onOnline) {
      window.removeEventListener("online", this._onOnline)
      window.removeEventListener("offline", this._onOffline)
    }
  }

  async registerServiceWorker() {
    try {
      const registration = await navigator.serviceWorker.register(this.swPathValue)

      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing
        if (!newWorker) return
        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
            this.showToast("Nueva versión disponible", "info")
          }
        })
      })
    } catch (error) {
      console.error("[PWA] Service worker registration failed:", error)
    }
  }

  setupOnlineOffline() {
    this._onOnline = () => {
      document.body.classList.remove("offline")
      this.showToast("Conexión restaurada", "success")
    }
    this._onOffline = () => {
      document.body.classList.add("offline")
      this.showToast("Sin conexión", "warning")
    }

    window.addEventListener("online", this._onOnline)
    window.addEventListener("offline", this._onOffline)

    if (!navigator.onLine) document.body.classList.add("offline")
  }

  showToast(message, type = "info") {
    const toast = document.createElement("div")
    toast.className = `pwa-toast pwa-toast--${type}`
    toast.textContent = message
    toast.setAttribute("role", "alert")

    document.body.appendChild(toast)
    requestAnimationFrame(() => toast.classList.add("pwa-toast--visible"))

    setTimeout(() => {
      toast.classList.remove("pwa-toast--visible")
      setTimeout(() => toast.remove(), 300)
    }, 4000)
  }
}
